import {
  FlowSetup,
  SetupRouteComponentProps
} from "../../../../shared/components/FlowSetup";
import { RouteSelectCorrectionType } from "./RouteSelectCorrectionType";
import { useHistory, useRouteMatch } from "react-router-dom";
import { RouteAddCorrectionValues } from "./RouteAddCorrectionValues";
import { RouteReviewCorrection } from "./RouteReviewCorrection";
import { RouteRequestCorrectionStatus } from "./RouteRequestCorrectionStatus";

type RequestCorrectionFlowProps = {
  basePath: string;
  onBack: () => Promise<void> | void;
  onFinish: () => Promise<void> | void;
};

export type SetupRequestCorrectionFlowProps = SetupRouteComponentProps<{}>;

export const RequestCorrectionFlow: React.FC<RequestCorrectionFlowProps> = ({
  basePath,
  onBack,
  onFinish
}) => {
  const history = useHistory();
  const match = useRouteMatch();
  return (
    <>
      <FlowSetup
        basePath={basePath}
        routes={[
          {
            path: "/select",
            component: RouteSelectCorrectionType,
            basePath,
            onBack: () => {
              onBack();
            },
            onNext: corrections => {
              history.push({
                pathname: `${match.url}/add`,
                state: {
                  corrections
                }
              });
            }
          },
          {
            path: "/add",
            component: RouteAddCorrectionValues,
            basePath,
            onBack: () => {
              onBack();
            },
            onNext: context => {
              history.push({
                pathname: `${match.url}/review`,
                state: {
                  ...context
                }
              });
            }
          },
          {
            path: "/review",
            component: RouteReviewCorrection,
            basePath,
            onBack: () => {
              onBack();
            },
            onNext: context => {
              if (context?.isEdit) {
                history.push({
                  pathname: `${match.url}/add`,
                  state: {
                    ...context
                  }
                });
              } else {
                history.push({
                  pathname: `${match.url}/status`,
                  state: {
                    ...context
                  }
                });
              }
            }
          },
          {
            path: "/status",
            component: RouteRequestCorrectionStatus,
            basePath,
            onBack: () => {
              onBack();
            },
            onNext: () => {
              onFinish?.();
            }
          }
        ]}
      />
    </>
  );
};
